import defaultFavicon from '@/assets/favicons/defaultFavicon.ico';
import newActionFavicon from '@/assets/favicons/newActionFavicon.ico';
export const DOCUMENT_TITLE = 'Monitoring Tool';
export const DOCUMENT_TITLE_SHORT = 'MT';

export const FAVICON_URLS = {
  DEFAULT: defaultFavicon,
  NEW_ACTION: newActionFavicon,
};
